export interface ColorFamily {
  enabledNames: string[]
}

/**
 * GrowthPalette Frontとしてサポートするカラー系統名の一覧
 * @see https://my-color.esa.io/posts/931
 */
const colorFamilyNames = [
  'white',
  'black',
  'gray',
  'brown',
  'beige',
  'green',
  'blue',
  'purple',
  'yellow',
  'pink',
  'red',
  'orange',
  'silver',
  'gold',
  'navy',
  'hazel',
  'olive',
  'clear',
  'special',
  'suikou',
] as const

export type ColorFamilyName = typeof colorFamilyNames[number]

export function isColorFamilyName(name: string): name is ColorFamilyName {
  return colorFamilyNames.some(n => n === name)
}
